import { AxiosResponse } from 'axios';
import { AppError } from './error-utils';

export class Result<T> {
  public isSuccess: boolean;
  public isFailure: boolean;
  private _error: T | string;
  private _value: T;

  public constructor(isSuccess: boolean, error?: T | string | null, value?: T) {
    if (isSuccess && error) {
      throw new Error('InvalidOperation: A result cannot be successful and contain an error');
    }
    if (!isSuccess && !error) {
      throw new Error('InvalidOperation: A failing result needs to contain an error message');
    }

    this.isSuccess = isSuccess;
    this.isFailure = !isSuccess;
    this._error = error || 'An Error Occured';
    this._value = value;

    Object.freeze(this);
  }

  public static success<U>(value?: U): Result<U> {
    return new Result<U>(true, null, value);
  }

  public static fail<U>(error: string | U): Result<U> {
    return new Result<U>(false, error);
  }

  public static combine(results: Result<any>[]): Result<any> {
    for (const result of results) {
      if (result.isFailure) return result;
    }
    return Result.success();
  }

  public getValue(): T {
    if (!this.isSuccess) {
      console.log(this._error);
      throw new Error("Can't get the value of an error result. Use 'errorValue' instead.");
    }

    return this._value;
  }

  public errorValue(): T {
    return this._error as T;
  }
}

export type APIErrorMessage = string;

export type APIResponse<T> = Result<T>;

export const returnAxios = async (fctAxios: Promise<AxiosResponse<any>>): Promise<APIResponse<any>> => {
  try {
    const response = await fctAxios;

    return Result.success<any>(response.data);
  } catch (err) {
    if (err.response && err.response.data) {
      const { type, message, details } = err.response.data;

      return Result.fail<AppError>(new AppError({ type, message, details }));
    }

    return Result.fail<any>('Connection failed');
  }
};
